<template>
  <div class="modal success-modal">
    <div class="modal-dialog">
      <div class="modal-content" v-click-outside="onClickOutside">
        <div class="modal-header">
          <div class="modal-title">
            <p>{{ title }}</p>
          </div>
          <button class="btn-plain close-modal" @click="$emit('close')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 8L16 16" stroke="#454647" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 8L8 16" stroke="#454647" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-modal-content">
            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32.9993" cy="33" r="24.01" stroke="#4BB34B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23.5127 33.9044L29.2938 39.6854L29.2564 39.6481L42.2992 26.6053" stroke="#4BB34B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p v-html="desc"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "click-outside-vue3";

export default {
  name: "VSuccessModal",
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    title: String,
    desc: String
  },
  data() {
    return {

    }
  },
  methods: {
    onClickOutside() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>